module.exports = __webpack_public_path__ + "media/images/flags/32/American-Samoa-bb60fba0a70c42375ad21a65929cd501.png";